import authStore, { redirectToLogin } from "../store/authStore";
import { message } from "antd";

const getToken = () => {
  const auth = authStore.getState().auth;

  if (auth?.token) {
    return auth.token;
  }

  redirectToLogin();
  message.warning("Token expired. Please login again!!");
};

export { redirectToLogin };
export default getToken;
